<template>
    <div>
            <compFormEdit ref="subAccountform" class="margin-top-15 margin-layout width-50per" :formdata="getBase" v-model="formData" :col="1" :labelWidth="120"></compFormEdit>
        <div class="text-right" v-if="querytype!='query'">
            <Button type="primary" @click="submit">确定</Button>
            <Button class="margin-left-10" @click="cancel">取消</Button>
        </div>
    </div>
</template>

<script>
import { HttpSubAccountUpdate,HttpSubAccountDetail } from '@/service/costbilling';
import { mapGetters } from 'vuex';
export default {
    props:['querytype','activeid','alertbox'],
    components: {
		compWrapper: () => import('@components/templates/wrapper'),
		compFormQuery: () => import('@components/templates/formquery'),
		compFormEdit: () => import('@components/templates/formedit'),
	},
    data(){
        return {
            type: this.$route.params.type || this.querytype,
            id: this.$route.query.id || this.activeid,
            formData:{
                billingType:0
            },
        }
    },
    created(){
        if(this.type=='add') return

        this.getDetail()
    },
    computed:{
        ...mapGetters('dictionary', ['getSelfmanageorgList']),
        getBase(){
            const isQuery = this.querytype === 'query';
            return [
                {
					label: this.$t('fbb.bill.sub_account_name', { defaultValue: "账号" }),
					key: "account",
                    tag: 'vInput',
                    required: true,
                    show: true,
                    query: isQuery
				},
                {
                    label: this.$t('global.common.organization', { defaultValue: "组织" }),
                    tag: 'vSelect',
                    key: 'orgId',
                    show: true,
                    required: true,
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    },
                    query: isQuery
                },
                {
                    label:this.$t('',{defaultValue:'计费类型'}),
                    tag:'vSelect',
                    key:'billingType',
                    show:true,
                    required:true,
                    options:[
                        {value:0,label:'系统报价'},
                        {value:1,label:'整体加点'}
                    ],
                },
                {
                    label:this.$t('',{defaultValue:'加点费率'}),
                    tag:'vInputNumber',
                    key:'coefficient',
                    show:this.formData.billingType===1,
                    required:true,
                    props:{
                        min:0
                    },
                    formItem: {
                        tip:
                            `<div class=color-error>${this.$t('fbb.accountmanage.warning_tip_2', { defaultValue: '加点系数, 数值为X ,代表原始金额*X' })}</div>`,
                    },
                },
                {
					label: this.$t('global.common.notes', { defaultValue: '备注' }),
					key: "remark",
                    tag: 'vTextarea',
                    required:false,
                    query: isQuery
				},
            ]
        }
    },
    methods:{
        getDetail(){
            HttpSubAccountDetail({
                id:this.id,
            }).then(res=>{
                this.formData = res.data;
            },err=>{
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        async submit(){
            let bool = await this.$refs.subAccountform.validate();
            if (!bool) return;
            HttpSubAccountUpdate({
                ...this.formData,
            }).then(res=>{
                this.$Message.success("保存成功");
                this.cancel();
                this.$emit('on-update')
            },err=>{
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            if (this.alertbox) {
                this.$emit('on-close')
            } else {
                this.$router.push({
                    name: 'costbillingSubAccountList',
                });
            }
        }
    }
}
</script>
